import { createI18n } from 'vue-i18n'
import { messages } from '../config/i18n'

const i18n = createI18n({
  locale: 'en-us',
  messages
})

export default i18n